export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.737Z",
    "Last-Translator": "",
    "Language-Team": "",
    "Language": "en-US",
    "Messages": {
        "Administracja": "Administration",
        "Aktywny": "Active",
        "Anuluj": "Cancel",
        "Brak pasujących dokumentów": "No matching documents",
        "Brak pasujących stron": "No matching pages",
        "Data dodania": "Date added",
        "Data indeksowania": "Indexing date",
        "Data modyfikacji": "Modification date",
        "Dodaj słowo": "Add word",
        "Dodaj synonim": "Add synonym",
        "Dodaj synonimy": "Add synonyms",
        "Dokument": "Document",
        "Dokumenty": "Documents",
        "Edytuj": "Edit",
        "Embeddings": "Embeddings",
        "Endpoint listy indeksów nie jest dostępny. Wdróż aktualną wersję API.": "Index list endpoint is unavailable. Deploy current API version.",
        "Health": "Health",
        "ID": "ID",
        "ID dokumentu": "Document ID",
        "ID encji": "Entity ID",
        "Indeks": "Index",
        "Lista indeksów": "List of indices",
        "Mappingi": "Mappings",
        "Nie dotyczy": "Not applicable",
        "Nie znaleziono dokumentu.": "Document not found.",
        "Otwarty": "Open",
        "Partycja": "Partition",
        "Podaj ID dokumentu i kliknij „Szukaj”, aby pobrać jego zawartość.": "Enter document ID and click “Search” to retrieve its content.",
        "Podgląd indeksu": "Index preview",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Przebudowanie indeksów": "Rebuilding indices",
        "Przebudowanie indeksów\n\nOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.\n\nNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "Rebuild indices\n\nOperation may take anywhere from a few seconds to several hours, depending on index size.\n\nUse only when changes made to synonym or stop word dictionaries need to be applied.",
        "Przeindeksowanie danych": "Data reindexing",
        "Przeindeksowanie danych\n\nOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.\n\nNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "Reindex data\n\nOperation may take anywhere from a few seconds to several hours, depending on amount of data in database.\n\nUse only if data appears to be missing from indices.",
        "Rozmiar": "Size",
        "Słowa wykluczone": "Excluded words",
        "Słowo": "Word",
        "Słowo wykluczone": "Excluded word",
        "Słowo zostało dodane.": "Word has been added.",
        "Słowo zostało usunięte.": "Word has been deleted.",
        "Słowo zostało zaktualizowane.": "Word has been updated.",
        "Spróbuj wpisać inną nazwę strony.": "Try entering a different page name.",
        "Status": "Status",
        "Statusy": "Statuses",
        "Strony": "Pages",
        "Synonimy": "Synonyms",
        "Synonimy zostały dodane.": "Synonyms have been added.",
        "Synonimy zostały usunięte.": "Synonyms have been deleted.",
        "Synonimy zostały zaktualizowane.": "Synonyms have been updated.",
        "System": "System",
        "Szczegóły": "Details",
        "Szczegóły dokumentu": "Document details",
        "Szkic": "Draft",
        "Szukaj": "Search",
        "Szukane słowo": "Searched word",
        "Typ encji": "Entity type",
        "Tytuł": "Title",
        "Ustawienia": "Settings",
        "Usuń": "Delete",
        "Usunięty": "Deleted",
        "Wpisz jedno słowo, które wyszukiwarka ma pomijać, np. „i” lub „oraz”. Każde słowo dodaj jako osobny wpis.": "Enter one word that search should ignore, e.g. “and” or “or”. Add each word as a separate entry.",
        "Wpisz każdy synonim w osobnym polu. Kliknij „Dodaj synonim”, aby dodać kolejne określenie.": "Enter each synonym in a separate field. Click “Add synonym” to add another term.",
        "Wpisz słowo główne, do którego chcesz przypisać alternatywne określenia używane przy wyszukiwaniu.": "Enter a primary word to associate with alternative terms used in searches.",
        "Wyszukiwanie": "Searching",
        "Zaakceptowany": "Accepted",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "Index rebuild task has started.",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "Data reindexing task has started.",
        "Zakończony": "Finished",
        "Zamknij": "Close",
        "Zapisz": "Save",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "Changes will take effect only after index rebuild.",
        "Zmień filtry lub wpisz inną frazę.": "Change filters or enter a different phrase."
    }
};
